import { formsActions } from "../slices/forms";
import { stateActions } from "../slices/states";
import { popupActions } from "../slices/popups";

let Actions = { ...formsActions, ...stateActions, ...popupActions };
export default Actions;
